<assessment-row title="Skin Appearance">
  <emr-list [list]="data.skinAppearance" emptyText="N/A"></emr-list>
  <p>{{ data.skinAppearanceComment }}</p>
</assessment-row>

<h2>Wounds</h2>
<assessment-row title="Location">
  <p>{{ data.location }}</p>
</assessment-row>

<assessment-row title="Staging">
  <p>{{ data.staging }}</p>
</assessment-row>

<assessment-row title="Care">
  <emr-list [list]="data.care" emptyText="None"></emr-list>
</assessment-row>
